import { createContext } from "react";

export const EasyContext = createContext();
